export default { commitHash: 'XXXXX', version: 'XXXXX' };
